module.exports = new __parcel__URL__("gestural-line-dark.5fb5d96c.svg").toString();